import React from 'react';
import { Search, RefreshCcw, ChevronDown } from 'lucide-react';
import { AuditEntityMapping } from '../types/audit-logs.types';

interface AuditFiltersProps {
  filters: any;
  onFilterChange: (filters: any) => void;
}

export function AuditFilters({ filters, onFilterChange }: AuditFiltersProps) {
  return (
    <div className="bg-white p-3 rounded-md border border-slate-100 shadow-sm flex flex-wrap items-center gap-3">
      {/* Search Input */}
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input
          type="text"
          placeholder="Tìm kiếm sự kiện, người dùng, IP..."
          className="w-full h-9 pl-9 pr-4 rounded-md border border-slate-200 bg-slate-50/50 sm:text-sm text-xs focus:outline-none focus:ring-1 focus:ring-emerald-500 transition-all"
          value={filters.search || ''}
          onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
        />
      </div>

      {/* Select Filters */}
      {[
        { label: 'Tất cả người dùng', key: 'actorId' },
        { label: 'Tất cả hành động', key: 'actionCode' },
        { label: 'Tất cả kết quả', key: 'result' },
        { label: 'Tất cả đối tượng', key: 'entityType', options: Object.entries(AuditEntityMapping) },
      ].map((select, idx) => (
        <div key={idx} className="relative group">
          <button className="h-9 px-3 pr-8 rounded-md border border-slate-200 bg-white sm:text-sm text-xs text-slate-600 hover:bg-slate-50 transition-all flex items-center min-w-[140px]">
            {select.label}
            <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          </button>
        </div>
      ))}

      {/* Reset Button */}
      <button 
        onClick={() => onFilterChange({})}
        className="h-9 px-4 rounded-md border border-slate-200 bg-white sm:text-sm text-xs text-slate-600 hover:bg-slate-50 transition-all flex items-center gap-2"
      >
        <RefreshCcw className="w-4 h-4" />
        Làm mới
      </button>
    </div>
  );
}
